import React from 'react'

export const ButtonAR = ({ objectInfo, language }) => {
  let URL

  const getMobileOperatingSystem = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera
    if (/android/i.test(userAgent)) {
      return 'Android'
    }
    if ((/iPad|iPhone|iPod/.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) && !window.MSStream) {
      return 'iOS'
    }
    return 'unknown'
  }

  if (getMobileOperatingSystem() === 'Android') {
    URL = `intent://arvr.google.com/scene-viewer/1.0?file=${encodeURIComponent(objectInfo?.ar?.glb)}#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=https://developers.google.com/ar;end;`
  } else if (getMobileOperatingSystem() === 'iOS') {
    URL = objectInfo?.ar?.usdz
  } else {
    URL = null
  }

  if (URL) {
    return (
      <a className='mt-12 text-center w-64' rel='ar' href={URL}>
        <img className='invisible' alt='ar' src={null} />
        <div>
          <svg className='m-auto' width='10vh' height='10vh' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 125' x='0px' y='0px'>
            <g data-name='Layer 3'>
              <path d='M14.59863,74.439a.99988.99988,0,0,1-.36621,1.36621l-1.73242,1a1.00016,1.00016,0,1,1-1-1.73242l1.73242-1A1.00037,1.00037,0,0,1,14.59863,74.439ZM41.72363,57.623l-3.45312,1.99414a1.00016,1.00016,0,0,0,1,1.73242l3.45313-1.99414a1.00016,1.00016,0,1,0-1-1.73242Zm-9.49707,5.4834-3.4541,1.99365a1.00016,1.00016,0,0,0,1,1.73242l3.4541-1.99365a1.00016,1.00016,0,0,0-1-1.73242ZM88.5,75.07275l-1.73242-1a1.00016,1.00016,0,1,0-1,1.73242l1.73242,1a1.00016,1.00016,0,1,0,1-1.73242Zm-7.40918-3.123a1.0001,1.0001,0,0,1-.86719.5,1.01413,1.01413,0,0,1-.14673-.01892L50.5,89.50684a1.0012,1.0012,0,0,1-1,0l-29.5769-17.076a1.01413,1.01413,0,0,1-.14673.01892A.99555.99555,0,0,1,19,70.82635V36.67969a.99985.99985,0,0,1,.5-.86621L49.07275,18.73987a.99192.99192,0,0,1,1.85461,0L80.5,35.81348a.99985.99985,0,0,1,.5.86621V70.82635A.995.995,0,0,1,81.09082,71.94971Zm-3.09058-.62933-1.72876-.99811a1.00016,1.00016,0,1,1,1-1.73242L79,69.58777V37.25684L51,21.09149v1.9964a1,1,0,1,1-2,0v-1.9964L21,37.25684V69.58777l1.72852-.99792a1.00016,1.00016,0,0,1,1,1.73242l-1.72876.99811L50,87.48584ZM71.22754,65.1001l-3.4541-1.99365a1.00016,1.00016,0,1,0-1,1.73242l3.4541,1.99365a1.00016,1.00016,0,1,0,1-1.73242Zm-9.498-5.48291L58.27637,57.623a1.00016,1.00016,0,1,0-1,1.73242l3.45313,1.99414a1.00016,1.00016,0,1,0,1-1.73242Zm-9.49707-5.4834L51,53.42242V52a1,1,0,0,0-2,0v1.42242l-1.23242.71136a1.00016,1.00016,0,0,0,1,1.73242L50,55.15485l1.23242.71136a1.00016,1.00016,0,0,0,1-1.73242ZM50,13.12158a.99974.99974,0,0,0,1-1v-2a1,1,0,0,0-2,0v2A.99974.99974,0,0,0,50,13.12158ZM50,46.021a.99974.99974,0,0,0,1-1V41.0332a1,1,0,0,0-2,0V45.021A.99974.99974,0,0,0,50,46.021Zm0-10.96631a.99974.99974,0,0,0,1-1V30.06689a1,1,0,0,0-2,0v3.98779A.99974.99974,0,0,0,50,35.05469ZM65,24h9v5.17432a1,1,0,1,0,2,0V23a.99974.99974,0,0,0-1-1H65a1,1,0,0,0,0,2ZM25,30.17432a.99974.99974,0,0,0,1-1V24h9a1,1,0,0,0,0-2H25a.99974.99974,0,0,0-1,1v6.17432A.99974.99974,0,0,0,25,30.17432ZM35,84H26V78.82568a1,1,0,0,0-2,0V85a.99974.99974,0,0,0,1,1H35a1,1,0,0,0,0-2Zm40-6.17432a.99974.99974,0,0,0-1,1V84H64.30664a1,1,0,0,0,0,2H75a.99974.99974,0,0,0,1-1V78.82568A.99974.99974,0,0,0,75,77.82568Z' />
            </g>
          </svg>
          <h3
            className='mt-0 mb-2 text-lg uppercase tracking-widest'
          >
            <b>
              {language === 'en' && ('Preview object in AR')}
              {language === 'es' && ('Ver este objeto en AR')}
              {language === 'it' && ('Vedi questo oggetto in AR')}
            </b>
          </h3>
          <h6
            className='mt-0 mb-6 text-xs text-gray-600'
          >
            {language === 'en' && ('iOS 13+, iPadOS 13+ o Android con ARCore 1.9+ required')}
            {language === 'es' && ('iOS 13+, iPadOS 13+ o Android con ARCore 1.9+ requirido')}
            {language === 'it' && ('Richiede iOS 13+, iPadOS 13+ o Android con ARCore 1.9+')}
          </h6>
        </div>
      </a>
    )
  } else {
    return null
  }
}
